import { z } from "zod";
import { StatisticsOverallOutputSchema } from "@/Schemas/Statistics/StatisticsOverallOutput";
import { StatisticsStateOutputSchema } from "@/Schemas/Statistics/StatisticsStateOutput";
import { StatisticsProcessingOutputSchema } from "@/Schemas/Statistics/StatisticsProcessingOutput";
import { StatisticsSourceOutputSchema } from "@/Schemas/Statistics/StatisticsSourceOutput";


export const StatisticsOutputSchema = z.object({
    overall: StatisticsOverallOutputSchema.nullable(),
    state: StatisticsStateOutputSchema.nullable(),
    processing: StatisticsProcessingOutputSchema.nullable(),
    source: StatisticsSourceOutputSchema.nullable(),
});

export type StatisticsOutput = z.infer<typeof StatisticsOutputSchema>;